import newportStandard from './themes/newport-standard';
//import newportXmas from './themes/newport-xmas';
//import newportBlackfriday from './themes/newport-blackfriday';

const theme = newportStandard
//const theme = newportXmas
//const theme = newportBlackfriday

export default theme